module.exports = __webpack_public_path__ + "static/media/W5390484_16.a51622db.jpg";